/**
 * @file コンポーネント：症例スライダー DOM管理
 */

// ライブラリ読み込み
import React from "react";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// コンポーネント読み込み
import { Operation } from "~/src/components/projects/Operation";

// スタイル読み込み
import {
    StyledSlider,
    StyledOperationWrapper
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    const [isMobile, setIsMobile] = useState(false);
    const prevButtonId = `button_prev_${props.sliderId}`;
    const nextButtonId = `button_next_${props.sliderId}`;

    /**
     * モバイル判定
     */
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 600); // sp: "600px"breakpoint.sp に合わせて調整
        };

        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    // ReactDOM
    return (
        <StyledSlider>
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                slidesPerView={isMobile ? 1 : 4}
                spaceBetween={16}
                loop={true}
                autoplay={{ delay: 3000 }}
                navigation={{
                    prevEl: `#${prevButtonId}`,
                    nextEl: `#${nextButtonId}`
                }}
                pagination={{ clickable: true }}
            >
                {props.list.map((operation, index) => (
                    <SwiperSlide key={index}>
                        <StyledOperationWrapper>
                            <Operation 
                                {...operation}
                                setIsOpenModalLogin={props.setIsOpenModalLogin}
                                />
                        </StyledOperationWrapper>
                    </SwiperSlide>
                ))}
            </Swiper>
            {/* 要素を作成 */}
            {!isMobile && props.list.length > 4 && (
                <>
                    <div id={prevButtonId} className="swiper-button-prev"></div>
                    <div id={nextButtonId} className="swiper-button-next"></div>
                </>
            )}
        </StyledSlider>
    );
};
